import { apiCall } from "../../../_utils";
import { apiUrls } from "../../../_constants";

export const mealConfigsServiceApi = {
    setWaterConfig,
    getWaterConfig,
    creteFoodMeasureService,
    updateFoodMeasureService,
    deleteFoodMeasureService,
    getAllFoodMeasureServices
};

function setWaterConfig(request) {
    return apiCall("PUT", `${apiUrls.food.configs}`, request);
}

function getWaterConfig() {
    return apiCall("GET", apiUrls.food.configs);
}

function creteFoodMeasureService(request) {
    return apiCall("POST", apiUrls.food.foodMeasures, request);
}

function updateFoodMeasureService(request, id) {
    return apiCall("PUT", `${apiUrls.food.foodMeasures}/${id}`, request);
}

function deleteFoodMeasureService(id) {
    return apiCall("DELETE", `${apiUrls.food.foodMeasures}/${id}`);
}


function getAllFoodMeasureServices(params){

    return apiCall("GET",apiUrls.food.foodMeasures,null,params)
}